// The Glow Trade — the €500 order minimum, re-checked at the moment checkout is clicked (owner, 2026-09-10).
//
// cart-summary.liquid and tgt-mini-cart.liquid render "Add products" instead of checkout below the
// minimum, but a rendered button can be stale. Three ways through, measured on STAGING: Enter in a /cart
// quantity field submits #cart-form through #checkout with the lowered quantity; a click beats Horizon's
// 300 ms quantity debounce; another tab or the back/forward cache shows an order sheet from before lines
// were removed. So a checkout click waits for pending cart writes, asks the server for the real total and
// only then continues. Enter on a focused field, button or link fires this same click.
//
// Still client-side: a typed /checkout or a cart permalink skips it. On Basic only a public App Store
// cart-validation app closes that; with bank-transfer-only payment an order below €500 is cancelled
// before anything is paid.

const CTA = 'button[name="checkout"], a[href="/checkout"]';
const BUSY = '.cart-items-disabled, .tgt-has-pending';
const sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms));
let checking = false;

document.addEventListener(
  'click',
  async (event) => {
    const cta = event.target instanceof Element ? event.target.closest(CTA) : null;
    if (!cta) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (checking) return;
    checking = true;
    cta.setAttribute('aria-busy', 'true');
    if (document.activeElement instanceof HTMLElement) document.activeElement.blur(); // commits a typed quantity
    await sleep(400); // outlasts Horizon's 300 ms quantity debounce
    for (let i = 0; i < 50 && document.querySelector(BUSY); i++) await sleep(100);
    // the threshold lives in cart-progress.liquid only; every surface with a checkout CTA renders it
    const min = Number(document.querySelector('[data-tgt-progress]')?.getAttribute('data-min'));
    const cart = await fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then((res) => (res.ok ? res.json() : null))
      .catch(() => null);
    checking = false;
    if (min > 0 && cart && cart.item_count > 0 && cart.total_price >= min) {
      // the native submit keeps what the cart form carries (note, updates[]); a link just follows
      if (cta instanceof HTMLButtonElement && cta.form) cta.form.requestSubmit(cta);
      else window.location.assign('/checkout');
      return;
    }
    window.location.reload(); // the server re-renders the gate for the cart it actually holds
  },
  true
);
